// extracted by mini-css-extract-plugin
export default {"container":"header-logo_container__k8JNV","logo":"header-logo_logo__pJtlX"};